import { schema } from 'normalizr'

const tableOrderItemPlan = new schema.Entity('tableOrderItemPlans')

export default tableOrderItemPlan
